import { render, staticRenderFns } from "./TagButton.vue?vue&type=template&id=18d0b70d"
import script from "./TagButton.vue?vue&type=script&lang=js"
export * from "./TagButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports